import { render, staticRenderFns } from "./rectify_appointment_feecontract.vue?vue&type=template&id=5b9b6f49"
import script from "./rectify_appointment_feecontract.vue?vue&type=script&lang=js"
export * from "./rectify_appointment_feecontract.vue?vue&type=script&lang=js"
import style0 from "./rectify_appointment_feecontract.vue?vue&type=style&index=0&id=5b9b6f49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports